'use strict';



import setModalVideo from "../../../frontend/js/video-modal";

class PageListVideoPlayer {
    constructor() {
        const playButtons = document.querySelectorAll('.membership-usp-list__play');

        if (playButtons.length > 0) {
            playButtons.forEach(element => {
                element.addEventListener('mouseup', function (event) {
                    if (event.which !== 1) {
                        return;
                    }
                    const videoId = element.dataset.videoId;
                    const videoHost = element.dataset.videoHost;
                    setModalVideo({ videoHost, videoId })
                });
            })
        }
    }
}
document.addEventListener("DOMContentLoaded", function () {
    new PageListVideoPlayer();
});